import { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import DropDownSingle from '../../../../../Components/DropDownSingle';
//mui imports==========
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
//=====================

//Size Config ( Renders Width And Height Components for Desktop,Mobile,Tablet )
const AspectRatioConfig = ({ keyData }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Grid
			container
			spacing={2}
			className={commonStyleClasses.basicOutlinedBox}
			style={{ margin: '4rem auto', width: '95%' }}
		>
			<Grid item xs={12} style={{ marginBottom: '3rem' }}>
				<Typography variant="h4">Aspect Ratio</Typography>
			</Grid>
			<ConfigUI keyData={keyData + '.DESKTOP'} deviceType="Desktop" />

			<ConfigUI keyData={keyData + '.MOBILE'} deviceType="Mobile" />

			<ConfigUI keyData={keyData + '.TABLET'} deviceType="Tablet" />
		</Grid>
	);
};

const ConfigUI = ({ keyData, deviceType }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Grid item xs={3.8} className={commonStyleClasses.basicOutlinedBox} style={{ margin: '.5rem' }}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography fontWeight={600} variant="h5">
						{deviceType}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<DropDownSingle
						keyData={keyData}
						label="Ratio"
						list={['4/3', '16/9']}
						formControlStyles={{ width: '100%' }}
						labelStyles={{ width: '100%' }}
						formControlVariant="outlined"
						selectInputStyles={{ margin: '1rem 0' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default AspectRatioConfig;
